import styled from "styled-components";

/**
 * 뉴스레터 지면 토큰.
 *
 * 사이트가 이미 쓰는 서체와 브랜드 색을 그대로 따른다 — 뉴스레터만 다른 세계처럼
 * 보이지 않게 한다. 여기서 하는 일은 본문을 읽기 좋게 만드는 것뿐이다:
 * 흰 바탕, 얇은 구분선, 넉넉한 여백, 또렷한 위계.
 */
export const Page = styled.main`
  --nl-ink: #1f1a12;
  --nl-ink-soft: #5c5346;
  /* 흰 바탕에서 4.6:1 — 작은 글자도 WCAG AA를 넘긴다. */
  --nl-ink-mute: #77706a;
  --nl-line: rgba(31, 26, 18, 0.12);
  --nl-line-strong: rgba(31, 26, 18, 0.22);
  --nl-surface: #f8f7f4;
  /* 브랜드 색. 게임 카테고리 화면에서 --nl-accent 는 게임 색으로 바뀌지만 이 값은 그대로다. */
  --nl-brand: #b58200;
  --nl-accent: var(--nl-brand);

  /* 한글 본문 한 줄 40자 안팎 */
  --nl-measure: 40rem;
  --nl-page: 46rem;

  background: #ffffff;
  color: var(--nl-ink);
  word-break: keep-all;
  overflow-wrap: break-word;
  /* GameSection 이 뷰포트 너비로 띠를 그린다. 세로 스크롤바 폭만큼 넘치는 부분을 잘라 낸다. */
  overflow-x: hidden;
  overflow-x: clip;
  /* 마지막 요소(구독 박스, 이전·다음 글)가 푸터에 붙지 않도록 */
  padding-bottom: 5rem;

  @media screen and (max-width: 768px) {
    padding-bottom: 3.5rem;
  }
`;

export const Wrap = styled.div`
  width: 100%;
  max-width: ${({ $wide }) => ($wide ? "var(--nl-page)" : "var(--nl-measure)")};
  margin: 0 auto;
  padding: 0 1.5rem;
`;

export const Button = styled.button`
  padding: 0.8125rem 1.75rem;
  border: 0;
  border-radius: 8px;
  background: var(--nl-ink);
  color: #ffffff;
  font-size: 0.9375rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.18s ease, opacity 0.18s ease;

  &:hover:not(:disabled) {
    background: #3a3125;
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid var(--nl-accent);
    outline-offset: 3px;
  }
`;

export const TextLink = styled.span`
  color: var(--nl-ink-soft);
  font-size: 0.875rem;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.18s ease;

  &:hover {
    color: var(--nl-ink);
  }

  &:focus-visible {
    outline: 2px solid var(--nl-accent);
    outline-offset: 3px;
    border-radius: 2px;
  }
`;
